<template>
    <div :class="['news', showOtherWidth ? '' : 'other-news']">
        <div class="banner" v-if="topContent.length > 0">
            <div class="item__banner" v-html="topContent[0].content"></div>
        </div>
        <div class="title" v-if="showTitle">
            <label>{{ data.title }}</label>
            <div class="tip">
                <span>{{ changeDateFormat(data.releaseTime) }}</span>
                <span>来源： {{ data.addr }}</span>
                <span>浏览量： {{ data.count }}</span>
            </div>
        </div>
        <div class="product" v-if="showProduct">
            <div class="product-top">
                <el-image class="info-image" :src="productImage"></el-image>
                <div class="product-top__info">
                    <span class="label">产品名称 :&nbsp;&nbsp; {{ data.name }}</span>
                    <span class="tip">品牌名称 :&nbsp;&nbsp; {{ data.brand }}</span>
                    <span class="tip">产品型号 :&nbsp;&nbsp; {{ data.model }}</span>
                    <div class="tag">
                        <el-tag type="success" v-for="(tag, index) in tagList" :key="index">{{tag.name}}</el-tag>
                    </div>
                    <div class="image-list">
                        <el-image :class="['info-image__view', activeIndex === index ? 'active' : '']"
                                  :src="image"
                                  v-for="(image, index) in imageList"
                                  :key="index" @click="changeProductImage(index)">
                        </el-image>
                    </div>
                </div>
            </div>
            <div class="product-bottom">
                <div class="product-tab">产品功能及技术参数</div>
                <div class="product-pwd">
                    <span class="tip">输入密码后显示</span>
                    <el-input v-model="password" placeholder="请输入密码..."></el-input>
                    <el-button @click="handleSubmitPwd">提交验证</el-button>
                    <div class="note">
                        请您拨打 <span>4000-848-868</span> 获取产品基本参数
                    </div>
                </div>
            </div>
        </div>
        <div class="content" v-if="showContent" v-html="data.content"></div>
        <div class="buttons" v-if="showButton && newsList">
            <div :class="['button', button.id  ? 'abled' : 'disabled']" v-for="(button, index) in newsList" :key="index" @click="button.id ? handleClick(index) : null">
                <el-icon v-if="index === 0" size="24" color="#666666"><ArrowLeft /></el-icon>
                <div class="button-text">
                    <span>{{ button.name }}</span>
                    <span>{{ index === 0 ? '上一篇' : '下一篇'}}</span>
                </div>
                <el-icon v-if="index === 1" size="24" color="#666666"><ArrowRight /></el-icon>
            </div>
        </div>
    </div>
</template>

<script>
import {getContentById, roundById} from "@/common/api";
import {ElMessage} from "element-plus";
import moment from "moment"
import mixin from "@/mixin"
import router from "@/route";
import {gsap} from "gsap";
export default {
    name: "newsVue",
    data() {
        return {
            tagList: [],
            labelList: [],
            showOtherWidth: false,
            password: "",
            activeIndex: 0,
            productImage: "",
            imageList: [],
            topContent: [],
            nodeList: [],
            data: {},
            showTitle: false,
            showButton: false,
            newsList: [],
            showContent: false,
            showProduct: false,
        }
    },
    mixins: [mixin],
    methods: {
        filterLabelTag(data) {
            this.tagList = [];
            if(data.labelIds !== null && data.labelIds !== undefined && data.labelIds !== "") {
                let tagList = data.labelIds.split(",")
                tagList.forEach(e=> {
                    let obj = this.labelList.filter(o=>o.id === e)[0];
                    this.tagList.push(obj)
                })
            }
            console.log(this.tagList)
        },
        handleSubmitPwd() {
            if(this.password === moment().format("YYMMDD")) {
                this.showContent = true;
            }else {
                ElMessage.warning("验证失败，请联系4000-848-868获取密码")
            }
        },
        changeProductImage(index) {
            this.activeIndex = index;
            this.productImage = this.imageList[index]
        },
        handleClick(index) {
            router.push({
                path: `/cvi/home/article/view`,
                query: {
                    newId: this.newsList[index].id,
                    type: new URL(location.href).searchParams.get('type'),
                    level: new URL(location.href).searchParams.get('level'),
                    activeTag: new URL(location.href).searchParams.get('activeTag'),
                    activeIndex: new URL(location.href).searchParams.get('activeIndex'),
                    parentId: new URL(location.href).searchParams.get('parentId'),
                    activeChildCard: new URL(location.href).searchParams.get('activeChildCard')
                }
            })
        },
        changeDateFormat(date) {
            return moment(date).format("YYYY年MM月DD日")
        },
        getRoundBy(id) {
            this.newsList = [];
            roundById(id).then(res=> {
                if(res.success) {
                    res.data.forEach(e=> {
                        if(e === null) {
                            this.newsList.push({
                                id: "",
                                name: "暂无"
                            })
                        }else{
                            this.newsList.push(e)
                        }
                    })
                    this.showButton = true;
                }else {
                    ElMessage.error(res.msg)
                }
            }).catch(()=>{
                ElMessage.error("获取上下级资源失败，请重试")
            })
        },
    },
    created() {
        this.getBanner();
        let id = new URL(location.href).searchParams.get('newId')
        getContentById(id).then(res=> {
            if(res.success) {
                this.showProduct = false;
                this.showContent = true;
                this.data = res.data
                let contentType = res.data.contentType;
                this.showTitle = [2].indexOf(contentType) > -1;
                this.showOtherWidth = [7, 6, 5].indexOf(contentType) > -1;
                this.showButton = [2, 3, 5, 6].indexOf(contentType) > -1;
                if(contentType === 3) {
                    this.showProduct = true;
                    this.showContent = false;
                    this.labelList = JSON.parse(sessionStorage.getItem('labelList'))
                    this.filterLabelTag(res.data)
                    if(this.data.imagePath !== "" && this.data.imagePath !== null && this.data.imagePath !== undefined) {
                        this.imageList = this.data.imagePath.split(",").slice(0, 3)
                        this.productImage = this.imageList[this.activeIndex]
                    }
                }
                this.getRoundBy(this.data.id)
            }else {
                ElMessage.error(res.msg)
            }
        }).catch(()=>{
            ElMessage.error("获取菜单资源失败，请刷新重试")
        })
    },
    mounted() {
        window.scrollTo(0, 0)
        this.$nextTick(()=> {
            gsap.set(".banner", {
                opacity: 0
            })
            gsap.to(".banner", {
                opacity: 1,
                duration: 1.5
            })
        })
    }
}
</script>

<style lang="less" scoped>
    .news {
        display: flex;
        flex-direction: column;
        align-items: center;
        background-color: #FFFFFF;
        padding-bottom: 90px;
        &.other-news {
            .content {
                max-width: 1200px;
                margin: 60px auto 0;
            }
        }
        .title {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 60px;
            margin-bottom: 40px;
            border-bottom: 1px solid #DFDFDF;
            label {
                font-size: 34px;
                font-weight: bold;
                line-height: 1;
                color: #184079;
            }
            .tip {
                margin: 32px auto;
                font-size: 14px;
                color: #666666;
                span {
                    margin-left: 90px;
                    &:nth-of-type(1) {
                        margin-left: 0;
                    }
                }
            }
        }
        .banner {
            width: 100%;
            ::v-deep img{
                width: 100% !important;
            }
        }
        .content {
            margin-top: 60px;
            min-height: 400px;
            ::v-deep p {
                padding: 10px 0;
                font-family: system-ui;
                line-height: 1.5;
                letter-spacing: 1px;
            }
            ::v-deep img {
                max-width: 100%;
            }
        }
        .info {
            margin-top: 60px;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding-bottom: 30px;
            border-bottom: 1px solid #DFDFDF;
            .info-title {
                font-size: 34px;
                line-height: 1;
                font-weight: bold;
                text-align: center;
                color: #184079;
            }
            .info-tip {
                margin-top: 30px;
                display: flex;
                align-items: center;
                span{
                    margin-right: 90px;
                    &:nth-last-of-type(1){
                        margin-right: 0;
                    }
                }
            }
        }
        .buttons {
            max-width: 1200px;
            width: 100%;
            margin: 90px auto 0;
            display: flex;
            align-items: center;
            .button {
                flex: 1;
                padding: 0 40px;
                height: 102px;
                background: #F6F6F6;
                cursor: pointer;
                display: flex;
                align-items: center;
                &.abled {
                    &:hover {
                        background: #FF6900;
                        .button-text {
                            span {
                                color: #FFFFFF;
                            }
                        }
                    }
                }
                &.disabled {
                    cursor: not-allowed;
                }
                &:nth-of-type(2) {
                    justify-content: flex-end;
                    .button-text {
                        margin-right: 10px;
                        span {
                            color: #666666;
                            text-align: right;
                        }
                    }
                }

                .button-text {
                    margin-left: 10px;
                    display: flex;
                    flex-direction: column;
                    span {
                        font-size: 16px;
                        color: #666666;
                        &:nth-of-type(2) {
                            margin-top: 4px;
                            font-size: 24px;
                        }
                    }
                }
            }
        }
    }
    .product {
        margin-top: 40px;
        width: 1200px;
        .product-top {
            display: flex;
            align-items: center;
            .info-image {
                width: 606px;
                height: 443px;
                flex-shrink: 0;
                border: 1px solid #DFDFDF;
            }
            .product-top__info {
                display: flex;
                margin-left: 25px;
                flex-direction: column;
                .label {
                    font-size: 24px;
                    color: #333333;
                    font-weight: bold;
                    margin-bottom: 40px;
                    display: inline-block;
                    line-height: 1;
                }
                .tip {
                    font-size: 16px;
                    color: #666666;
                    display: inline-block;
                    line-height: 1;
                    margin-bottom: 15px;
                }
                .tag {
                    display: flex;
                    flex-wrap: wrap;
                    ::v-deep .el-tag {
                        margin-right: 10px;
                        padding: 4px 10px !important;
                        margin-bottom: 8px;
                        font-size: 14px;
                        background: #ff6600;
                        border: none;
                        color: #FFFFFF;
                    }
                }
            }
            .image-list {
                margin-top: 25px;
                .info-image__view {
                    margin-right: 12px;
                    width: 179px;
                    height: 126px;
                    border: 1px solid #DFDFDF;
                    cursor: pointer;
                    &.active {
                        border-color: #FF6900;
                    }
                    &:nth-last-of-type(1) {
                        margin-right: 0;
                    }
                }
            }
        }
        .product-bottom {
            margin-top: 56px;
            width: 100%;
            .product-tab {
                font-size: 18px;
                color: #333333;
                font-weight: bold;
                line-height: 1;
                padding-bottom: 10px;
                border-bottom: 1px solid #DFDFDF;
            }
            .product-pwd {
                margin-top: 45px;
                display: flex;
                align-items: center;
                .tip {
                    font-size: 18px;
                    color: #666666;
                    margin-right: 20px;
                }
                ::v-deep .el-input {
                    width: 181px;
                    height: 41px;
                    .el-input__wrapper {
                        border: 1px solid #DFDFDF;
                        border-radius: 0;
                        box-shadow: none;
                        background: #FFFFFF;
                    }
                }
                .el-button {
                    margin-left: 20px;
                    margin-right: 20px;
                    width: 120px;
                    height: 40px;
                    background: #FF6900;
                    border-radius: 0;
                    color: #FFFFFF;
                }
                .note {
                    font-size: 18px;
                    color: #666666;
                    span {
                        font-size: 24px;
                        color: #FF6900;
                    }
                }
            }
        }
    }
</style>
